interface FaqItem {
  question: string;
  answer: string;
}

const faqs: FaqItem[] = [
  {
    question: '天天影视的综艺节目真的全部免费吗？',
    answer: '是的，天天影视所有综艺节目完全免费在线观看，无需注册会员、无需付费订阅。我们致力于为综艺爱好者提供最便捷的观看体验，高清画质、流畅播放，没有任何隐藏收费。欢迎随时打开天天影视，享受免费的综艺盛宴。',
  },
  {
    question: '综艺节目更新速度怎么样？',
    answer: '天天影视每日同步更新各大热门综艺的最新内容。一般来说，节目播出后的24小时内，高清版本就会同步上线。热门真人秀、脱口秀等节目的更新尤其及时，确保你不错过任何精彩内容。你可以在"最新动态"板块查看每天的更新快讯。',
  },
  {
    question: '观看的时候会缓冲卡顿吗？',
    answer: '天天影视采用智能码率自适应和多线路加速技术，大部分网络环境下都能实现流畅播放不缓冲。平台会根据你的网络状况自动调整画质和码率，确保最佳观看体验。如果遇到卡顿，可以尝试切换网络或降低画质设置。',
  },
  {
    question: '手机和平板可以看吗？',
    answer: '当然可以！天天影视全面适配电脑、平板和手机端。你可以通过浏览器直接访问，也可以下载天天影视的 iOS 或 Android 客户端，获得更便捷的移动观看体验。所有设备上的观看记录和收藏内容可以同步，无缝切换。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            关于天天影视
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            快速解答你关于综艺观看的常见疑问
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 text-base md:text-lg font-bold text-foreground-900 list-none">
                <h3 className="pr-4">{faq.question}</h3>
                <span className="shrink-0 w-8 h-8 rounded-full bg-background-100 flex items-center justify-center transition-transform duration-300 group-open:rotate-45">
                  <i className="ri-add-line text-foreground-600"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}